import get from 'lodash/get';
import api from 'services/api';
import * as types from './types';
import { selectWhatsNewIsFetched, selectWhatsNewIsFetching, selectWhatsNewIsUnavailable } from './selectors';

// A backend without the endpoint answers 404, and a role without the `info`
// permission answers 403. Neither changes during a session, so those are the only
// failures that stop the thunk from retrying; logging out resets the slice.
const PERMANENT_ERROR_STATUSES = [403, 404];

/**
 * GET WHAT'S NEW
 * Fetches the changelog. It is a no-op when a request is already in flight,
 * when the changelog was already fetched, or when the backend does not serve it.
 * @returns {Function} Redux thunk.
 */
// eslint-disable-next-line import/prefer-default-export
export function getWhatsNew () {
  return async (dispatch, getState) => {
    const state = getState();
    if (selectWhatsNewIsFetching(state) || selectWhatsNewIsFetched(state) || selectWhatsNewIsUnavailable(state)) return;

    dispatch({ type: types.GET_WHATS_NEW_START });
    try {
      const data = await api.whatsNew.fetchWhatsNew();
      dispatch({
        type: types.GET_WHATS_NEW_SUCCESS,
        changelogUrl: get(data, 'changelogUrl', ''),
        versions: get(data, 'versions', [])
      });
    } catch (e) {
      dispatch({
        type: types.GET_WHATS_NEW_FAIL,
        error: get(e, 'message', 'There was an error, please try again'),
        isPermanent: PERMANENT_ERROR_STATUSES.includes(get(e, 'status'))
      });
    }
  };
}
